import { gql } from 'graphql-tag';

export const CREATE_PROPOSAL_ON_SUBMISSION_APPROVAL = gql`
  mutation CreateProposalOnSubmissionApproval($input: CreateProposalV2Input!) {
    createProposalOnSubmissionApproval(input: $input) {
      id
      success
      errorMessage
      vendorOpportunityId
    }
  }
`;
